import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Spacer from "./Spacer";
import { cssProp } from "./helpers";

const Layout = styled(Spacer)<{
  vertical?: boolean;
  horizontal?: boolean;
  childrenGrow?: boolean;
  gap?: string;
  responsive?: boolean;
}>(
  ({ vertical, horizontal, gap, childrenGrow, responsive }) => css`
    display: flex;
    ${!!vertical ? "flex-direction:column;" : ""}
    ${!!horizontal ? "flex-direction:row;" : ""}
		${!!childrenGrow ? "* {flex-grow: 1;}" : ""}
		${!!responsive ? "flex-wrap: wrap;" : ""}
		${cssProp("gap", gap)}
  `
);

export default Layout;
